import { type SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

export type MemberContext = 'commandbar' | 'member' | 'admin' | 'moderation'

export enum MemberActionItemType {
  View = 'View',
  Edit = 'Edit',
  Share = 'Share',
  ManageBadges = 'ManageBadges',
  Analytics = 'Analytics',
  AuditLogs = 'AuditLogs',
  ResetPassword = 'ResetPassword',
  VerifyEmail = 'VerifyEmail',
  Remove = 'Remove',
  Report = 'Report',
  Suspend = 'Suspend',
  Flag = 'Flag',
  RevokeSuspension = 'RevokeSuspension',
}

export type MemberActionItem = {
  name: string
  url?: string
  icon?: SvgIconName
  action?: (props: unknown) => void
  category?: string
  hotkey?: string
  type: MemberActionItemType
}
